import { GetServerSidePropsContext, Redirect } from "next";
import { stringify } from "qs";
import { Dispatch, Store } from "redux";

import { getGeolocation } from "api/requests/getGeolocation";
import { updateLocationServerSide } from "redux/action-creators/location";
import { LocationLoadAction } from "redux/reducers/location";
import { getCity, getStateCode } from "redux/selectors/location";

interface CustomGetServerSidePropsContext extends GetServerSidePropsContext {
  store: Store;
}

const encodeString = (input: string) => {
  return input.replaceAll(" ", "+").toLowerCase();
};
export const encodeLocation = (input: { city: string; state_code: string }) => {
  return encodeString(`${input.city} ${input.state_code}`);
};

const getLocationFromAddress = async (address: string) => {
  try {
    const location = await getGeolocation({ address });
    return location;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const updateLocation = async (
  location: { city: string; state_code: string },
  dispatch: Dispatch<LocationLoadAction>,
  req: GetServerSidePropsContext["req"],
  res: GetServerSidePropsContext["res"],
) => {
  await new Promise<void>((resolve) => {
    updateLocationServerSide(dispatch, location, req, res);
    resolve();
  });
};

const syncUrlWithUserLocation = async (
  context: CustomGetServerSidePropsContext,
): Promise<{
  redirect: Redirect | null;
}> => {
  const { req, res, query, store, resolvedUrl } = context;
  const { dispatch } = store;
  const reduxState = store.getState();
  const pageRoute = resolvedUrl.split("?")[0];

  const { location: urlSlug, ...otherQueryParams } = query as {
    location: string;
  };
  const reduxCity = getCity(reduxState);
  const reduxStateCode = getStateCode(reduxState);
  const reduxLocation = encodeLocation({
    city: reduxCity,
    state_code: reduxStateCode as string,
  });

  const formattedUrlSlug = urlSlug ? encodeString(urlSlug) : "";

  const queryString = stringify(otherQueryParams);

  if (!formattedUrlSlug && reduxLocation) {
    const destination = `${pageRoute}?location=${reduxLocation}${queryString ? `&${queryString}` : ""}`;

    return {
      redirect: {
        destination,
        statusCode: 302,
      },
    };
  }

  if (formattedUrlSlug && formattedUrlSlug !== reduxLocation) {
    const address = formattedUrlSlug.replace("+", ", ");
    const location = await getLocationFromAddress(address);
    if (location) {
      await updateLocation(location, dispatch, req, res);
      const updatedLocationSlug = encodeLocation(location);
      const destination = `${pageRoute}?location=${updatedLocationSlug}${queryString ? `&${queryString}` : ""}`;

      return {
        redirect: {
          destination,
          statusCode: 302,
        },
      };
    }
    const destination = `${pageRoute}?location=${reduxLocation}${queryString ? `&${queryString}` : ""}`;

    return {
      redirect: {
        destination,
        statusCode: 302,
      },
    };
  }
  return {
    redirect: null,
  };
};

export default syncUrlWithUserLocation;
